import {
  SET_BOOKMARKS,
  REMOVE_BOOKMARK,
  ADD_BOOKMARK,
} from 'legacy/src/constants/types';

const initialState = [];

const bookmarks = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BOOKMARKS:
      return payload;
    case ADD_BOOKMARK:
      return [...state, payload];
    case REMOVE_BOOKMARK:
      return state.filter((ref) => ref !== payload);
    default:
      return state;
  }
};

export default bookmarks;
